import React from 'react';
import { IntlProvider } from 'react-intl';
import { useSelectedLanguageQuery } from './getSelectedLanguage.generated';
import { SUPPORTED_LANGUAGES } from '../languageTools';

const languageSupported = (lang) =>
  lang && SUPPORTED_LANGUAGES.includes(lang.toLowerCase());

const extractLanguage = (data) => {
  if (!data?.viewer?.b2bProfileSettings?.language) {
    return null;
  }

  const {
    viewer: {
      b2bProfileSettings: { language },
    },
  } = data;

  if (!languageSupported(language)) {
    return null;
  }

  return language;
};

const setLocaleToWindow = (resp, langFromProps) => {
  (window as any).locale =
    extractLanguage(resp?.viewer?.b2bProfileSettings?.language) ||
    langFromProps;
};

const RecruitingSettingsFetcher = ({ WrappedComponent, ...props }) => {
  const { data, loading } = useSelectedLanguageQuery({
    onCompleted(resp) {
      setLocaleToWindow(resp, props.language);
    },
  });

  if (loading) return null;

  const language = extractLanguage(data) || props.language;

  return (
    <IntlProvider
      locale={language}
      messages={require(`../../../../i18n/onlyfy/locales/${language}`).messages}
    >
      <WrappedComponent {...props} language={language} />
    </IntlProvider>
  );
};

const withSelectedLanguage =
  (Component) =>
  ({ ...props }) => {
    return (
      <RecruitingSettingsFetcher WrappedComponent={Component} {...props} />
    );
  };

const LoginLanguageSettings = ({ children, ...props }) => {
  const { data, loading } = useSelectedLanguageQuery({
    onCompleted(resp) {
      setLocaleToWindow(resp, props.language);
    },
  });

  if (loading) return null;

  const language = extractLanguage(data) || props.language;

  return (
    <IntlProvider
      locale={language}
      messages={require(`../../../../i18n/onlyfy/locales/${language}`).messages}
    >
      {children}
    </IntlProvider>
  );
};

export { withSelectedLanguage, LoginLanguageSettings };
